// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"521":"9d4faa840a229a0c","547":"5c8d01c81c48853d","642":"9bfe2deda2790b12"}[chunkId] + ".js";
};